export default function (context, value) {
    context.dispatch('settings/open', 'statements', {root: true});
}